'use strict';

export default class HeaderMenu {
  constructor() {



    // The menu
    $('#block-mainnavigation li:last-child a').click(function ($event) {
      $event.preventDefault();
      $('body').toggleClass('show-menu');
    })


    $('.close-menu').on('click', function ($event) {
      $event.preventDefault();
      $('body').toggleClass('show-menu');
    })

  }
}
